import Vue from 'vue'

export default new Vue({
    methods: {
        template(show) {
            this.$emit('changedLoadingTemplate', show);
        },
        templateShowChanged(callback) {
            this.$on('changedLoadingTemplate', callback)
        },

        header(show) {
            this.$emit('changedLoadingHeader', show);
        },
        headerShowChanged(callback) {
            this.$on('changedLoadingHeader', callback)
        },
        
        sidebar(show) {
            this.$emit('changedLoadingSidebar', show);
        },
        sidebarShowChanged(callback) {
            this.$on('changedLoadingSidebar', callback)
        },

        main(show) {
            this.$emit('changedLoadingMain', show);
        },
        mainShowChanged(callback) {
            this.$on('changedLoadingMain', callback)
        },
        
        footer(show) {
            this.$emit('changedLoadingFooter', show);
        },
        footerShowChanged(callback) {
            this.$on('changedLoadingFooter', callback)
        },
    }
})